import { render } from "./TheButtonGrid.vue?vue&type=template&id=6862c872&scoped=true"
import script from "./TheButtonGrid.vue?vue&type=script&lang=js"
export * from "./TheButtonGrid.vue?vue&type=script&lang=js"

import "./TheButtonGrid.vue?vue&type=style&index=0&id=6862c872&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6862c872"]])

export default __exports__